import { UBXInputTypeEnum } from './form.model';

export class UBXFieldInput {
    type: UBXInputTypeEnum;
    step?: number;
    showHide?: boolean;
}
export class UBXFieldCheckbox {
    onClick?: (value: any) => void;
    isChecked?: boolean;
    isReverse?: boolean;
}
export class UBXFieldSelect {
    onClick?: (value: any) => void;
    isSelected?: any;
    options?: Array<UBXFieldOption<string | number | boolean>>;
    groups?: Array<UBXFieldOptionGroup>;
}
export class UBXFieldDate {
    min?: Date;
    max?: Date;
}
export class UBXFieldOption<TValue> {
    label: string;
    value: TValue;
}
export class UBXFieldOptionGroup {
    label: string;
    options: Array<UBXFieldOption<string | number | boolean>>;
}
export class UBXFieldRadio {
    onClick?: (value: any) => void;
    isSelected?: any;
    options?: Array<UBXFieldOption<string | number | boolean>>;
}
export class UBXFieldButtonGroup {
    buttons: Array<UBXFieldButton>;
    columns?: string;
    gap?: string | number;
    xGap?: string;
    yGap?: string;
    jc?: string;
    ji?: string;
    ac?: string;
    ai?: string;
}
export class UBXFieldButton {
    name: string;
    label: string;
    color: string;
    type: string;
    action: (value: any) => void;
    icon?: UBXFieldButtonIcon;
    isDisabled?: boolean;
}
export class UBXFieldButtonIcon {
    left?: string;
    right?: string;
}
